<template>
    <div>
        <v-dialog
            transition="slide-x-transition"
            :width="1150"
            persistent
            scrollable
            v-model="display">
            <v-card>
                <v-card-title>
                    {{ title }}
                    <v-spacer></v-spacer>
                    <!-- <v-switch v-if="notEditMode" label="SMS" v-model="form.send_sms"></v-switch> -->
                    <v-menu
                        offset-y>
                        <template v-slot:activator="{on}">
                            <v-btn
                                icon
                                v-on="on"
                                class="mx-1">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list width="250" dense>
                            <v-list-item
                                v-if="hasSalesOrder"
                                @click="openSalesOrderDisplayDialog()"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('copy_from_sales_order') }}</v-list-item-title>
                            </v-list-item> 
                            <v-list-item
                                @click="openLineDialogForNew()"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-database-plus</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('new_invoice_line') }}</v-list-item-title>
                            </v-list-item> 
                            <v-list-item
                                v-if="selected.invoiceItemLine.length == 1"
                                @click="openLineDialogForEdit()"
                                link
                                >
                                <v-list-item-icon>
                                    <v-icon >mdi-pencil</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('edit_invoice_line') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="selected.invoiceItemLine.length"
                                @click="deleteInvoiceItemLine(selected.invoiceItemLine[0])"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('delete_invoice_line') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-card-title>
                <v-card-subtitle></v-card-subtitle>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-row>
                            <v-col cols="4">
                                <v-menu
                                    ref="menu"
                                    v-model="menu.date"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        hide-details="auto"
                                        v-model="form.date"
                                        :rules="rules.date"
                                        :disabled="uneditableField('date')"
                                        :label="$t('date')"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="form.date" 
                                        @input="menu.date = false" 
                                        no-title 
                                        scrollable
                                        @change="setDueDate">
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    ref="due_date"
                                    v-model="menu.due_date"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        hide-details="auto"
                                        v-model="form.due_date"
                                        :rules="rules.due_date"
                                        :disabled="uneditableField('due_date')"
                                        :label="$t('due_date')"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker :min="form.date" v-model="form.due_date" @input="menu.due_date = false" no-title scrollable></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <customer-search
                                    :label="$t('customer')"
                                    item-text="display_name"
                                    v-model="form.customer_id"
                                    :rules="rules.customer">
                                </customer-search>
                            </v-col>
                            <v-col cols="4">
                                <v-select
                                    dense
                                    hide-details="auto"
                                    :disabled="uneditableField('site_id')"
                                    :label="$t('sites_customer')"
                                    v-model="form.site_id"
                                    :items="sites"
                                    :rules="rules.site_id"
                                    item-text="name"
                                    item-value="id">
                                </v-select>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    dense
                                    hide-details="auto"
                                    :append-icon="hasNoSalesOrder ? 'mdi-magnify' : null"
                                    :readonly="hasSalesOrder"
                                    :clearable="hasSalesOrder"
                                    @click:clear="clearSalesOrder"
                                    @keypress.enter="openSalesOrderSearchDialog"
                                    @blur="hasNoSalesOrder ? clearSalesOrder() : null"
                                    v-model="form.sales_order"
                                    :rules="rules.sales_order_id"
                                    :disabled="hasLines"
                                    :label="$t('blanket_agreement')">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    :label="$t('branch')"
                                    dense
                                    :items="branches"
                                    :loading="branchesLoading"
                                    @update:search-input="searchBranches"
                                    :rules="rules.branch_id"
                                    item-text="name"
                                    item-value="id"
                                    v-model="form.branch_id"
                                    hide-details="auto"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-data-table
                            class="mt-4"
                            dense
                            hide-default-footer
                            disable-pagination
                            show-select
                            single-select
                            item-key="row_id"
                            :items="form.invoice_item_lines"
                            v-model="selected.invoiceItemLine"
                            :headers="headers.invoiceItemLine">
                            <template v-slot:[`item.sales_order_item_id`] ="{ item }">
                                <v-icon :color="item.sales_order_item_id ? 'success' : 'error'">
                                    {{ item.sales_order_item_id ? 'mdi-check-circle' : 'mdi-alert-circle'  }}
                                </v-icon>
                            </template>
                            <template v-slot:[`item.price`]="{ item }">
                                {{ formatPrice(item.price) }}
                            </template>
                            <template v-slot:[`item.quantity`]="{ item }">
                                {{ formatPrice(item.quantity) }} {{ item.measure_unit }}
                            </template>
                            <template v-slot:[`item.total`]="{ item }">
                                {{ formatPrice(item.total) }}
                            </template>
                            <template v-slot:[`item.subtotal`]="{ item }">
                                {{ formatPrice(item.subtotal) }}
                            </template>
                            <template v-slot:[`item.tax`]="{ item }">
                                {{ formatPrice(item.tax) }}
                            </template>
                            <template v-slot:[`item.discount`]="{ item }">
                                {{ formatPrice(item.discount) }}
                            </template>
                            <template v-if="form.invoice_item_lines" slot="body.append">
                                <tr>
                                    <td colspan="7"></td>
                                    <td><b>{{ $t('sub_total') }}</b></td>
                                    <td><b>{{ formatNumber(subtotal, 2) }}</b></td>
                                </tr>
                                <tr>
                                    <td colspan="7"></td>
                                    <td>{{ $t('discount') }}</td>
                                    <td>{{ formatNumber(discount, 2) }}</td>
                                </tr>
                                <tr>
                                    <td colspan="7"></td>
                                    <td>{{ $t('tax') }}</td>
                                    <td>{{ formatNumber(tax, 2) }}</td>
                                </tr>
                                <tr>
                                    <td colspan="7"></td>
                                    <td><b>{{ $t('total') }}</b></td>
                                    <td><b>{{ formatMoney(total, "SDG ", 2) }}</b></td>
                                </tr>
                            </template>
                        </v-data-table>
                        <v-textarea
                            class="mt-10"
                            rows="2"
                            v-if="!!form.invoice_item_lines.length"
                            dense
                            hide-details
                            outlined
                            :label="$t('note')">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        :disabled="loading.data || !valid || loading.submit || !form.invoice_item_lines.length"
                        :loading="loading.submit"
                        @click="submit"
                        >
                        {{ $t("save_btn" )}}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="attemptClose">
                        {{ $t("cancel_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/> -->
        <CustomerSearchDialog
            @store="fetchCustomerName"
            ref="customerSearchDialog"/>
        <InvoiceItemLineDialog
            v-if="lineDialog.display"
            ref="invoiceItemLineDialog"
            :display="lineDialog.display"
            @close="closeLineDialog"
            @submit="lineHandler"
            :line="lineDialog.line"
            :editMode="lineDialog.editMode"
            />
        <DecisionDialog
            ref="decisionDialog"
            @submit="onDecisionDialogSubmit"/>
        <AlertDialog 
            ref="alertDialog"/>
        <SalesOrderSearchDialog
            v-if="salesOrderSearchDialog.display"
            :display="salesOrderSearchDialog.display"
            :customer-id="salesOrderSearchDialog.customerId"
            :search="this.salesOrderSearchDialog.search"
            @close="closeSalesOrderSearchDialog"
            @submit="catchSubmittedSalesOrderFromSearchDialog"/>
        <SalesOrderDisplayDialog
            ref="salesOrderDisplayDialog"
            :selectable="true"
            @select="pushSelectedSalesOrderLines"
            />
    </div>
</template>
<script>



import uneditableField from '@/utils/uneditableField';
import AlertDialog from '@/components/common/AlertDialog';
// import RetryDialog from '@/components/common/RetryDialog';
import CustomerSearchDialog from '@/components/Sales/CustomerSearchDialog';
import InvoiceItemLineDialog from '@/components/Sales/InvoiceItemLineDialog';
import DecisionDialog from '@/components/common/DecisionDialog';
import formatPrice from '@/utils/formatPrice';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import { random, assign, clone, isEmpty, isNull } from 'lodash';
// import {formatNumber} from 'accounting';
import SalesOrderSearchDialog from '../Sales/SalesOrderSearchDialog';
import SalesOrderDisplayDialog from '../Sales/SalesOrderDisplayDialog';
import {formatNumber, formatMoney} from 'accounting';
// import PCustomerSearch from './PCustomerSearch.vue';
import CustomerSearch from '../searchComponents/CustomerSearch.vue';
import { getCustomer } from '../../services/sales/customer';
import branch from './../../services/sales/branch';

export default {
    name: "InvoiceDialog",
    components: {
    //    RetryDialog,
        CustomerSearchDialog,
        InvoiceItemLineDialog,
        AlertDialog,
        DecisionDialog,
        SalesOrderSearchDialog,
        SalesOrderDisplayDialog,
        // PCustomerSearch,
        CustomerSearch
    },
    props: {
        id: {
            type: Number,
            required: false
        },
        // display: {
        //     type: Boolean,
        //     required: true
        // },
        data: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            taxPercentage: 17,
            subtotal: 0,
            tax: 0,
            discount: 0,
            total: 0,
            valid: false,
            display: true,
            menu: {
                date: null,
                due_date: null
            },
            loading: {
                data: true,
                submit: false,
            },
            headers: {
                invoiceItemLine: [
                    { text: this.$t('item'), value: "item" },
                    { text: this.$t('cast_type'), value: "cast_type" }, 
                    { text: this.$t('quantity'), value: "quantity" },
                    // { text: this.$t('unit_measure'), value: "measure_unit" },
                    { text: this.$t('price'), value: "price" },
                    { text: this.$t('sub_total'), value: "subtotal" },
                    { text: this.$t('discount'), value: "discount" },
                    { text: this.$t('tax_percentage'), value: "tax" },
                    { text: this.$t('total'), value: "total" }
                ]
            },
            customer: null,
            selected: {
                invoiceItemLine: []
            },
            form: {
                date: null,
                due_date: null,
                customer: null,
                customer_id: null,
                site_id: null,
                sales_order_id: null,
                sales_order: null,
                invoice_item_lines: [],
                send_sms: false,
                branch_id: null
            },
            rules: {
                date: [
                    v => !!v || this.$t('rules_required')
                ],
                due_date: [
                    v => !!v || this.$t('rules_required')
                ],
                customer: [
                    v => !!v || this.$t('rules_required')
                ],
                site_id: [
                    v => !!v || this.$t('rules_required')
                ],
                branch_id: [
                    v => !!v || this.$t('rules_required')
                ]
            },
            lineDialog: {
                display: false,
                editMode: false,
                line: {}
            },
            salesOrderSearchDialog: {
                display: false,
                customerId: null
            },
            branches: [],
            branchesLoading: false
        }
    },
    watch: {
        "form.invoice_item_lines": {
            handler() {
                // this.calculateLineTotals();
                this.calculateTotals();
            },
            deep: true
        },
        "form.customer_id": {
            handler() {
                if(this.form.customer_id)  this.fetchSites({ customer_id: this.form.customer_id });
            },
            deep: true
        },
        "form.branch_id": {
            handler() {
                localStorage.setItem("default_sales_branch", this.form.branch_id)
            }
        }
    },
    computed: {
        ...mapState('sales/customer', ["customerSearch"]),
        title() {
            if(this.notEditMode) return this.$t('new_invoice')
            else return this.$t('edit_invoice')
        },
        hasLines() {
            return this.form.invoice_item_lines.length > 0;
        },
        hasSalesOrder() {
            return !this.hasNoSalesOrder;
        },
        hasNoSalesOrder() {
            return !this.form.sales_order_id;
        },
        hasCustomer() {
            return !this.hasNoCustomer;
        },
        hasNoCustomer() {
            return !this.form.customer_id;
        },
        editMode() {
            return this.id != null;
        },
        notEditMode() {    
            return !this.editMode;
        },
        ...mapState('sales/invoice', ["invoice"]),
        ...mapState('sales/site', ["sites"])
    },
    methods: {
        formatPrice,
        formatNumber,
        formatMoney,
        uneditableField,
        ...mapActions('sales/invoice', ["fetchinvoices", "fetchInvoice", "storeInvoice", "updateInvoice"]),
        ...mapActions('sales/site', ["fetchSites"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        ...mapActions("sales/dpk", ["fetchDpk"]),
        ...mapActions("sales/customer", ["setCustomersFromSearch"]),
        customerExistInStore(customerId) {
            return this.customerSearch.indexOf(this.customerSearch.find(each => each.id == customerId)) === -1 ? false : true ;
        },
        getCustomerData(customerId) {
            if(this.customerExistInStore(customerId)) return;
            getCustomer(customerId).then(response => this.setCustomersFromSearch([response.data]));
        },
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.form.dpk = dpk.key;
        },
        async createdDataFetch() {
            try {
                if(this.editMode) {
                    await this.fetchInvoice(this.id);
                    this.form = clone(this.invoice);
                    await this.fetchSites({ customer_id: this.form.customer_id });
                    this.getCustomerData(this.form.customer_id);
                } else {
                    this.getDpkData();
                    this.form.branch_id = Number(localStorage.getItem("default_sales_branch"))
                }
                this.loading.data = false
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        openCustomerSearchDialog() {
            this.$refs.customerSearchDialog.open(this.form.customer);
        },
        openSalesOrderSearchDialog() {
            this.salesOrderSearchDialog.display = true;
            this.salesOrderSearchDialog.search = this.form.sales_order;
            this.salesOrderSearchDialog.customerId = this.form.customer_id;
        },
        closeSalesOrderSearchDialog() {
            this.salesOrderSearchDialog.display = false;
        },
        setCustomerName(name) {
            this.form.customer = name;
        },
        fetchCustomerName(params) {
            this.form.customer_id = params.id;
            this.form.customer = params.name;
            this.fetchSites({ customer_id: params.id }); 
        },
        openLineDialog() {
            this.lineDialog.display = true;
        },
        closeLineDialog() {
            this.lineDialog.display = false;
            this.lineDialog.line = {}
        },
        openLineDialogForNew() {
            this.lineDialog.editMode = false;
            this.openLineDialog();
        },
        openLineDialogForEdit() {
            this.lineDialog.editMode = true;
            this.lineDialog.line = clone(this.selected.invoiceItemLine[0], true);
            this.openLineDialog();
        },
        lineHandler(line) {
            if(isNull(line.row_id)) this.addNewLine(line);
            else this.updateExistingLine(line);
            this.closeLineDialog();
        },
        addNewLine(line) {
            line.row_id = random(9999);
            this.form.invoice_item_lines.push(line);
        },
        updateExistingLine(line) {
            let itemLine = this.form.invoice_item_lines.find((each) => each.row_id == line.row_id );
            assign(itemLine, line);
        },
        // pushLine(line) {
        //     if(!line.row_id) {
        //         line.row_id = random(9999);
        //         this.form.invoice_item_lines.push(line);
        //         this.closeLineDialog();
        //     } else {
        //         let itemLine = this.form.invoice_item_lines.find((each) => each.row_id == line.row_id );
        //         assign(itemLine, line);
        //         this.closeLineDialog();
        //     }
        // },
        catchSubmittedSalesOrderFromSearchDialog(salesOrder) {
            this.setSalesOrder(salesOrder);
            this.closeSalesOrderSearchDialog();
        },
        setSalesOrder(salesOrder) {
            this.form.sales_order_id = salesOrder.id;
            this.form.sales_order = salesOrder.code;
            this.$emit("setSalesOrder", salesOrder);
        },
        clearSalesOrder() {
            this.form.sales_order_id = null;
            this.form.sales_order = null;
            this.form.invoice_item_lines = [];
        },
        setCustomer({customer, customerId}) {
            this.form.customer = customer;
            this.form.customer_id = customerId;
        },
        clearCustomer() {
            this.form.customer = null;
            this.form.customer_id = null;
            this.$emit("clearCustomer");
        },
        openSalesOrderDisplayDialog() {
            this.$refs.salesOrderDisplayDialog.open({id: this.form.sales_order_id})
        },
        pushSelectedSalesOrderLines(line) {
            this.$refs.salesOrderDisplayDialog.close();
            this.openLineDialogForCopy(line);
        },
        openLineDialogForCopy(line) {
            this.lineDialog.editMode = false;
            this.lineDialog.line = clone(this.prepareCopiedLine(line), true);
            this.openLineDialog();
        },
        prepareCopiedLine(line) {
            return {
                id: null,
                row_id: null,
                item: line.item,
                item_id: line.item_id,
                cast_type: line.cast_type,
                cast_type_id: line.cast_type_id,
                measure_unit_id: line.measure_unit_id,
                measure_unit: line.measure_unit,
                quantity: line.quantity,
                price: line.price,
                is_taxable: line.is_taxable,
                tax: line.tax,
                discount: 0,
            }
        },
        deleteInvoiceItemLine(params) {
            let index = this.form.invoice_item_lines.indexOf(params);
            this.form.invoice_item_lines.splice(index, 1);
            this.selected.invoiceItemLine = [];
        },
        submit() {
            this.loading.submit = true;
            if(this.notEditMode) {
                this.storeInvoice(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                        // this.$refs.alertDialog.open({type: "success", message: this.$t("record_save_success")});
                    })
                    .catch(error => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            } else {
                this.updateInvoice(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                        // this.$refs.alertDialog.open({type: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }

        },
        attemptClose(){
            if(this.form.invoice_item_lines.length){
                this.$refs.decisionDialog.open({title: this.$t('confirm_title'), content: this.$t('are_you_sure'), target: 'closeDialog'})
            } else {
                this.close();
            }
        },
        onDecisionDialogSubmit(params){
            if(params.target == 'closeDialog') this.close();
        },
        close() {
            // this.display = false;
            setTimeout(() => this.$emit("close"), 500);
        },
        setDueDate() {
            this.form.due_date = this.form.date;
        },
        setDatesToCurrent() {
            this.form.date = moment().format("YYYY-MM-DD");
            this.form.due_date = moment().format("YYYY-MM-DD");
        },
        setCustomerFromProps() {
            this.form.customer = this.data.customer;
            this.form.customer_id = this.data.customer_id;
        },
        // calculateLineTotals() {
        //     this.form.invoice_item_lines.forEach(line => {
        //         line.subtotal = parseFloat(line.quantity * line.price);
        //         line.tax = line.is_taxable === true ? parseFloat(line.subtotal * (this.taxPercentage/100)) : 0;
        //         line.total = line.subtotal + line.tax - line.discount;
        //     });
        // },
        calculateTotals() {
            var fields = ["subtotal", "tax", "discount", "total"];
            fields.forEach(field => this[field] = this.getTotalOf(field));
        },
        getTotalOf(field) {
            return this.form.invoice_item_lines.reduce((total, line) =>  total += line[field] , 0);
        },
        searchBranches(query) {
            this.branchesLoading = true;
            branch.search(query).then(res => {
                this.branches = [...this.branches, ...res.data];
            }).finally(() => {
                this.branchesLoading = false;
            })
        }
    },
    created() {
        this.setDatesToCurrent();
        this.createdDataFetch();
        if(!isEmpty(this.data)) this.setCustomerFromProps();
    },
    updated() {
        // this.$refs.form.validate();
        this.$on("clearCustomer", () => this.clearSalesOrder());
        this.$on("setSalesOrder", (salesOrder) => this.setCustomer({customer: salesOrder.customer, customerId: salesOrder.customer_id}))
    }
}
</script>